import React from 'react';
import {useState, useEffect} from 'react';
import axios from "axios";
import { API_URL } from 'api/config';
import PropertyCardSkeleton from './PropertyCardSkeleton';
import StayCard from 'components/StayCard/StayCard';
import Pagination from 'shared/Pagination/Pagination';
import { Link } from "react-router-dom";
import {PlusIcon} from "@heroicons/react/24/outline";
import { useNavigate } from 'react-router-dom';
const PageHome = () => {
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const ItemsPerPage = 8;
  const [propertyData, setPropertyData] = useState<any>([]);
  const navigate = useNavigate();

  const getOwnerProperty = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(
        `${API_URL}/property/get-owner-property`,
        {
          headers: {
            token: token,
          },
        }
      );
      if (response.data.error === false) {
        const property = response.data.propertydata;
      
        setPropertyData(property);
      }
    } catch (err) {
      console.error("error while fetching properties data", err);
    }
  };
  
    useEffect(() => {
      getOwnerProperty();
    }, []);

    
    const scrollToView = () => {
      const PropertyTop = document.getElementById("PropertyTop");
      PropertyTop?.scrollIntoView({
        behavior: "smooth",
      });
    };
    useEffect(() => {
      if (Array.isArray(propertyData)) {
        setCurrentPage(1);
      }
    }, [propertyData]);
    
  const totalPages = Math.ceil(propertyData.length / ItemsPerPage);

  const startIndex = (currentPage - 1) * ItemsPerPage;
  const endIndex = Math.min(startIndex + ItemsPerPage, propertyData.length);

  const currentData = propertyData.slice(startIndex, endIndex);
  const nextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
    scrollToView();
  };
  const prevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
    scrollToView();
  };

const token = localStorage.getItem("token");
  return (
    <div className="container md:mt-14 mt-8">
      <div className='flex justify-between sm:hidden my-1'>
        <h1 className='text-xl font-semibold text-center'>My properties</h1>
        <span onClick={() => navigate('/add-property')} className='cursor-pointer hover:bg-zinc-300 rounded'>
          <PlusIcon className='h-8 w-8'/>
        </span>
      </div>
      
  <div className='nc-SectionGridFeaturePlaces relative mb-5 flex-grow-1 w-full'>
    {!token ? (
      <>
      <p className='text-center'>Please <Link to='/login' className='underline text-blue-700'>login</Link> to view your properties 
      
      </p>
      </>
    ) : (
            <>
            {loading ? (
              <PropertyCardSkeleton />
            ) : currentData.length > 0 ? (
              <div
                className={`grid gap-6 md:gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 `}
              >
                {currentData.map((property: any) => (
                  <StayCard
                    key={property._id}
                    currentProperty={property}
                    data={property}
                    size={"default"}
                    className=""
                  />
                ))}
              </div>
            ) : (
              <div className="flex justify-center items-center text-gray-500">
                <p>No properties available</p>
              </div>
            )}
          </>
    )}
    
        {currentData.length > 0 ? (
          <div className="flex my-16 justify-center items-center">
            <Pagination
              className=""
              totalPages={totalPages}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              scrollToView={scrollToView}
              onNext={nextPage}
              onPrev={prevPage}
            />
          </div>
        ) : (
          ""
        )}
    </div>
    </div>
  
  )
}

export default PageHome
